<div class="mb-1" [ngClass]="{'mt-1rem':!isArchive}">
  <div class="ptb-archive" *ngIf="isArchive">
    <div class="mt-12 ml-1-5 archive-banner width-max-content">
      <div class="archive-btn">
        <span class="version-general-header">Archive Version : {{archiveVersion}}</span>
      </div>
      <div role="button" class="back-close-btn" tabindex="0" (click)="BackToCurrentContent()" (keyup.enter)="BackToCurrentContent()" tabindex="0">
        <img src="../../../assets/icons/arrow-left-blue.svg" class="current-content-back-arrow-icon" alt="Arrow Left">
        <span class="underline">Back to Current GARS Version</span>
      </div>
    </div>
  </div>
  <div class="generalPage">
    <div class=" flex-display fullComponent">
      <div class="pr-96px pt-3 print-content print-all-content">
        <div class="pendingheading ">{{copyrightHeader}}</div>

        <div class="content ptr-32" [innerHTML]="copyrightBody"></div>
        <div class="mt-40px h-20px flex-display" id="copyrightpermission" (click)="OpenLink($event)" [innerHTML]="clickForInformation"></div>

      </div>
    </div>
  </div>
</div>

